module.exports = __webpack_public_path__ + "static/img/manual_zh_13.2e4e6b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_13.png
// module id = Bl5n
// module chunks = 4